import type { ComponentProps } from 'react';
import { cx } from '@/styled-system/css';
import { skeletonBlock } from './skeletonBlock.styles';

type SkeletonBlockProps = ComponentProps<'span'>;

export function SkeletonBlock({ className, ...props }: SkeletonBlockProps) {
  return <span {...props} aria-hidden="true" className={cx(skeletonBlock, className)} />;
}
